function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Location({
  width = 16,
  height = 20,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94 0C3.601.11.11 3.658 0 8.065a9.04 9.04 0 001.037 3.723l.061.112c4.8 7.814 6.234 7.814 6.842 7.814.953 0 1.981-.68 4.412-4.153a64.458 64.458 0 002.413-3.665l.062-.108a9.039 9.039 0 001.054-3.723C15.771 3.658 12.28.11 7.941 0zm5.735 11.201s-4.411 7.17-5.735 7.17c-1.323 0-5.734-7.17-5.734-7.17a7.734 7.734 0 01-.883-3.136c0-3.712 2.963-6.72 6.617-6.72 3.655 0 6.617 3.008 6.617 6.72a7.732 7.732 0 01-.895 3.136h.013z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94 3.285c-1.965 0-3.56 1.716-3.56 3.833 0 2.118 1.595 3.834 3.56 3.834 1.966 0 3.56-1.716 3.56-3.834 0-2.117-1.594-3.833-3.56-3.833zm0 6.23c-1.228 0-2.224-1.073-2.224-2.397 0-1.323.996-2.395 2.224-2.395 1.229 0 2.225 1.072 2.225 2.395 0 1.324-.996 2.396-2.225 2.396z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Location.js.map